import { RadioGroup } from '@headlessui/react';

const radioOptionClasses = {
  active: 'ring-2 ring-white ring-opacity-60 ring-offset-2 ring-offset-sky-600',
  checked: 'bg-primaryBlue text-white',
  unchecked: 'bg-white',
};

export default function RadioOption({ value, checked }) {
  return (
    <RadioGroup.Option
      className={({ active }) =>
        `${active ? radioOptionClasses.active : ''}
  ${checked ? radioOptionClasses.checked : radioOptionClasses.unchecked}
  flex h-40 cursor-pointer rounded-lg p-3 shadow-md focus:outline-none md:p-5`
      }
      value={value}
    >
      {({ checked }) => (
        <>
          <div className="flex w-[15rem] flex-col items-center justify-center text-lg">
            <RadioGroup.Label
              as="p"
              className={`text-center font-medium  ${checked ? 'text-white' : 'text-black'}`}
            >
              {value.title}
            </RadioGroup.Label>
            <RadioGroup.Description
              className={`text-center ${checked ? 'text-gray-100' : 'text-gray-500'}`}
            >
              {value.subTitle}
            </RadioGroup.Description>
          </div>
        </>
      )}
    </RadioGroup.Option>
  );
}
